import Information from '@assets/icons/information.svg'
import { Icon } from './Icon'

export const InformationIcon = Icon(Information)
